module.exports = __webpack_public_path__ + "img/H30-2.png";